import CommentUserAvatar from './CommentUserAvatar';
import CommentUserName from './CommentUserName';
import CommentCreatedAt from './CommentCreatedAt';
import { type UserSummary } from '@/lib/types';
import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';

const UserWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const UserInfoWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  [mediaQuery(1024)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

type CommentUserProps = {
  user: UserSummary | null;
  createdAt: string;
};

const CommentUser = ({ user, createdAt }: CommentUserProps) => (
  <UserWrapper>
    {user !== null && <CommentUserAvatar user={user} />}
    <UserInfoWrapper>
      {user !== null && <CommentUserName name={user.name} />}
      <CommentCreatedAt createdAt={createdAt} />
    </UserInfoWrapper>
  </UserWrapper>
);

export default CommentUser;
